import { render, staticRenderFns } from "./StudentReportGrid.vue?vue&type=template&id=9a195f24&scoped=true&"
import script from "./StudentReportGrid.vue?vue&type=script&lang=js&"
export * from "./StudentReportGrid.vue?vue&type=script&lang=js&"
import style0 from "./StudentReportGrid.vue?vue&type=style&index=0&id=9a195f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a195f24",
  null
  
)

export default component.exports